import React, { CSSProperties } from "react";
import Popup from "./Popup";
import { Link } from "react-router-dom";
import { ActionOption, isButton } from "../utils";

interface PopupProps {
  text?: string;
  isOpen: boolean;
  onClose: () => void;
  options: ActionOption[];
  positionStyle: CSSProperties;
}

const OptionsPopup: React.FC<PopupProps> = ({
  text,
  isOpen,
  onClose,
  options,
  positionStyle,
}: PopupProps) => {
  const linkButtonClasses = "w-full text-left text-sm hover:bg-gray-200";
  return (
    <Popup isOpen={isOpen} onClose={onClose} positionStyle={positionStyle}>
      {text && <div className="text-xl font-bold">{text}</div>}
      <div className="divide-y divide-gray-200">
        {options.map((option) => (
          <div key={option.label}>
            {isButton(option) ? (
              <button
                className={linkButtonClasses}
                onClick={(event) => {
                  event.stopPropagation();
                  option.onClick();
                  onClose();
                }}
              >
                {option.label}
              </button>
            ) : (
              <Link
                to={option.href}
                className={linkButtonClasses}
                onClick={onClose}
              >
                {option.label}
              </Link>
            )}
          </div>
        ))}
      </div>
    </Popup>
  );
};

export default OptionsPopup;
